export default "__VITE_ASSET__DoGBbU4E__"